import {
  ClbLayout,
  ClbLayoutContent,
  ClbLayoutHeader,
} from "@celebration/react";
import { useHotjar, useNps } from "@hooks/index";
import Header from "@template/components/Header";
import LayoutCollapseProvider from "@template/contexts/LayoutCollapse.provider";
import type React from "react";
import { Outlet } from "react-router-dom";

const Layout: React.FC = () => {
  useNps();
  useHotjar();

  return (
    <LayoutCollapseProvider>
      <ClbLayout>
        <ClbLayoutHeader>
          <Header />
        </ClbLayoutHeader>
        <ClbLayoutContent>
          <Outlet />
        </ClbLayoutContent>
      </ClbLayout>
    </LayoutCollapseProvider>
  );
};

export default Layout;
